module.exports = __webpack_public_path__ + "static/media/villasofia-parkkipaikat.ad9ad6ee.png";